module.exports = __webpack_public_path__ + "static/media/amazon.fea38bbf.svg";